import { cApi } from '@/config/env';
export default {
    //获取图片验证码
    getCodeImg: { url: cApi + '/captchaImage', method: 'get' },
    //演员编辑系统登录
    login: { url: cApi + '/noFilter/actorEdit/login', method: 'post' },
    //更新演员
    actorEditSave: { url: cApi + '/noFilter/sp/web/actorEditSave', method: 'post' },
    //获取演员详情
    getSpActorInfo: { url: cApi + '/noFilter/actorEdit/actorEditGetDetail', method: 'post' },
    //更新演员
    actorEditSave: { url: cApi + '/noFilter/actorEdit/actorEditSave', method: 'post' },

};


// WEBPACK FOOTER //
// ./src/api/external.js